/* eslint-disable no-nested-ternary */ // TODO: remove this later
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';

import './UsersList.scss';

interface UsersHeaderProps {
  totalRecords: number;
  setIsAddUserDialogOpen?: (isAddUserDialogOpen: boolean) => void; // TODO remove conditional
  setIsBulkUserDialogOpen?: (isBulkUserDialogOpen: boolean) => void;
  enableBulkUpload: boolean;
  searchInput: string;
  handleTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  status: string;
  showSearchField?: boolean;
  showAddIcon?: boolean;
}

const UsersHeader: React.FC<UsersHeaderProps> = ({
  totalRecords,
  setIsAddUserDialogOpen,
  enableBulkUpload,
  setIsBulkUserDialogOpen,
  searchInput,
  handleTextChange,
  status,
  showSearchField = true,
  showAddIcon = true,
}) => {
  const headerStatus =
    status === 'loading' ? 'Loading...' : `${totalRecords} Users`;

  const isShowingAddIcon = showAddIcon && !!setIsAddUserDialogOpen;

  return (
    <div className="UsersList-header">
      <div id="users-count">{headerStatus}</div>
      <div className="SearchAndActions">
        {showSearchField && (
          <TextField
            id="outlined-basic"
            variant="outlined"
            size="small"
            className="usersInput"
            value={searchInput}
            onChange={handleTextChange}
            placeholder="Search"
            autoFocus
          />
        )}
        {isShowingAddIcon && (
          <Button
            size="small"
            variant="contained"
            aria-label="close"
            color="secondary"
            onClick={() =>
              setIsAddUserDialogOpen && setIsAddUserDialogOpen(true)
            }
            disableRipple
            className="addIconButton"
          >
            <AddIcon style={{ color: 'white' }} />
          </Button>
        )}
        {isShowingAddIcon && enableBulkUpload && (
          <Button
            variant="contained"
            aria-label="close"
            color="secondary"
            onClick={() =>
              setIsBulkUserDialogOpen && setIsBulkUserDialogOpen(true)
            }
            disableRipple
            className="addIconButton-bulk"
          >
            <AddIcon style={{ color: 'white' }} /> Upload
          </Button>
        )}
      </div>
    </div>
  );
};

export default UsersHeader;
